import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

import { RootStateContext } from "../../states/root.state";
import { LegacyOrderImport } from "../../types/legacy";
import ExcelFileDrop from "../form/excelFileDrop.comp";
import ExcelFileInput from "../form/excelFileInput.comp";

export default function ImportLegacyOrder() {
  const [excelData, setExcelData] = useState<LegacyOrderImport[] | null>(null);
  const { push } = useRouter();
  const { legacyOrderImportService } = useContext(RootStateContext);

  useEffect(() => {
    if (!excelData) return;

    legacyOrderImportService.send({ type: "SELECT_FILE", orders: excelData });
    push("/import/legacyOrder/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    legacyOrderImportService.stop();
    legacyOrderImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" className="space-y-4">
      <h2>Legacy Order Import</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
}
